import styled from 'styled-components'

import { sm } from '@ucheba/utils/helpers/styles/mixins'

const ListStyled = styled.ul<{ isOneItem: boolean }>`
  display: grid;
  grid-template-columns: auto auto;
  column-gap: 48px;
  row-gap: 32px;
  align-items: baseline;

  ${sm.resetList};
  ${sm.resetLastMb};

  ${({ isOneItem }) =>
    isOneItem &&
    `
      grid-template-columns: auto;

      li {
        width: calc(50% - 24px);
      }
    `}
`

const CoverTouch = styled.img`
  width: 100%;
  max-width: 470px;
  min-height: 164px;

  border-radius: 8px;
`

const Cover = styled(CoverTouch)`
  height: 200px;
`

const Space = styled.div`
  margin-top: 48px;
`

export { ListStyled, CoverTouch, Cover, Space }
